export enum AutoCalculatePrice {
    DoNotAutoCalculatePrice = 0,
    Percentage = 1,
    DollarAmount = 2,
}
